import { FormItem } from '@models/FormItem'
import { Typography } from 'antd'
import { FC } from 'react'

const { Text } = Typography

interface AssociatedItemPreviewProps {
  item: FormItem
}

const AssociatedItemPreview: FC<AssociatedItemPreviewProps> = ({ item }) => {
  if (!item.associatedItems || item.associatedItems.length === 0) {
    return <></>
  }

  return (
    <div
      style={{
        backgroundColor: 'rgba(217, 217, 217, 0.2)',
        borderRadius: '10px',
        padding: '12px',
        marginTop: '8px',
      }}
    >
      <Text
        type="secondary"
        style={{
          fontSize: '14px',
          lineHeight: '22px',
          display: 'block',
          whiteSpace: 'pre-wrap',
        }}
      >
        Réponse à la campagne précédente
      </Text>
      <Text
        type="secondary"
        style={{
          fontSize: '14px',
          lineHeight: '22px',
          display: 'block',
          whiteSpace: 'pre-wrap',
        }}
      >
        Si une réponse à la question est trouvée pour l'employé, elle sera
        affichée ici.
      </Text>
    </div>
  )
}

export default AssociatedItemPreview
